import { render, staticRenderFns } from "./ItemBundle.vue?vue&type=template&id=90afadc4&"
import script from "./ItemBundle.vue?vue&type=script&lang=js&"
export * from "./ItemBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports